import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiCorePackage } from '@wix/da-papi-types';
import { formatDollars } from '@wix/da-shared-react/pkg/utils/formatting';
import s from './CoreMonthlyPriceAndCycle.scss';

interface Props {
  className?: string;
  corePackage: PapiCorePackage;
  priceStyle?: 'regular' | 'bold' | 'extra-bold';
  shouldPackageShowDiscount?: boolean;
  showPriceBeforeDiscountOnly?: boolean;
  reverseOrder?: boolean; // true: [Price] - [Price before Discount], false: [Price before Discount] - [Price]
}

const CoreMonthlyPriceAndCycle: React.FC<Props> = ({
  className,
  corePackage,
  priceStyle = 'regular',
  shouldPackageShowDiscount,
  showPriceBeforeDiscountOnly,
  reverseOrder,
}) => {
  const { t } = useTranslation();
  const { interval, monthlyPrice, monthlyPriceBeforeDiscount } = corePackage;

  return (
    <div
      className={cn(s['root'], reverseOrder && s['reverse-order'], className)}
    >
      {shouldPackageShowDiscount &&
        !showPriceBeforeDiscountOnly &&
        monthlyPriceBeforeDiscount &&
        interval === 'month' && (
          <div className={s['price-before-discount']}>
            {formatDollars(monthlyPriceBeforeDiscount)}
          </div>
        )}
      <div className={cn(s['price'], s[priceStyle])}>
        {formatDollars(
          shouldPackageShowDiscount && !showPriceBeforeDiscountOnly
            ? monthlyPrice
            : monthlyPriceBeforeDiscount ?? monthlyPrice
        )}
      </div>
      {interval === 'year' ? (
        <>
          <div className={s['times']}>&times;</div>
          <div>{t('packagePicker.billingCycle.new.12months')}</div>
        </>
      ) : (
        !shouldPackageShowDiscount /* monthly discount applies for only one month */ && (
          <>
            <div className={s['slash']}>/</div>
            <div>{t('packagePicker.billingCycle.new.month')}</div>
          </>
        )
      )}
    </div>
  );
};
CoreMonthlyPriceAndCycle.displayName = 'CoreMonthlyPriceAndCycle';

export default CoreMonthlyPriceAndCycle;
